<header class="mast-main-head fixed-top" *ngIf="mobileViewSection">
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container left-header-subscribe">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
    </div>
  </nav>
</header>

<header class="masthead">
	<div class="navbar">
		<div class="left-header" style="margin-left: 12px;">
				<button style="width: 260px;" id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon">
					<a (click)="backToWorkspace()" class="navbar-brand js-scroll-trigger left-header-backpress" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
				<div class="lib-icon-blue">
					<img src="assets/img/user-profile.svg">
				</div>
				<h4 class="content-lib-txt">My Profile</h4>
			</button>

      <div class="lib-icon-sec" mat-raised-button #tooltip="matTooltip"
			matTooltip="Library"
			matTooltipPosition="below"
			matTooltipClass="custom-tooltip" (click)="goToLibrary()">
				<img src="assets/img/lib-icon.svg">
			</div>
		</div>

		<div class="right-header" style="width: 500px;">
      <div class="menu-pop-over anticon-bell">
        <a href="javascript:;" class="upgrade-txt" (click)="goToSubscription()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>
			</div>

      <div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>

								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
										</div>
										<div>
											<div class="user-info-name">
												<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
											</div>
											<div class="" style="margin-top: 4px;">
												<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<a *ngIf="!currentUser" class="nav-link button" data-toggle="modal" (click)="openLoginScreen()" data-target="#signup-popup" style="background: #DEEBFF; color: #2d7cff; width: 160px;  margin-left: 24px; cursor: pointer;">Start for Free</a>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
						<img *ngIf="!userPic" src="assets/img/user-profile.svg">
						<img *ngIf="userPic" class="profile-user-img" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
              <div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
              <div class="hr-line"></div>
              <a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
              <a (click)="goToSubscription()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="mobile-view-section" *ngIf="mobileViewSection">
	<div class="container">
		<div class="row">
		  <img src="assets/img/laptop.svg" alt="">
		  <div class="text-container">
		    <h4>Switch to Desktop</h4>
		    <p>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</p>
		  </div>
		</div>
	</div>
</section>

<section class="my-profile-section" *ngIf="profileSection">
	<div class="center-container">
		<div class="center-container">
			<div class="main-profile-area" style="display: flex;">
				<div class="col-sm-3 user-data">
					<div class="profile-sec-user-pic">
						<img *ngIf="!userPic" class="user-img" src="assets/img/user-profile.svg">
						<img *ngIf="userPic" class="user-img" src="{{userPic}}">

            <span *ngIf="(currentUserRating == null || currentUserRating == '') && userRole == 'Owner'">🎖️</span>
            <span *ngIf="(currentUserRating == null || currentUserRating == '') && userRole != 'Owner'"></span>
            <span *ngIf="currentUserRating == 1 && userRole != 'Owner'">😐</span>
            <span *ngIf="currentUserRating == 2 && userRole != 'Owner'">🎉</span>
            <span *ngIf="currentUserRating == 3 && userRole != 'Owner'">🥉</span>
            <span *ngIf="currentUserRating == 4 && userRole != 'Owner'">🥈</span>
            <span *ngIf="currentUserRating == 5 && userRole != 'Owner'">🥇</span>
						<!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" width="36px" height="36px">
							<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
						</svg> -->
					</div>
					<div class="user-details">
						<div class="user-name">
							<h2>{{userFullName}}</h2>

							<div class="profile-more-section">
                <label class="change-picture-label" mat-raised-button #tooltip="matTooltip"
  							matTooltip="Change picture"
  							matTooltipPosition="above"
  							matTooltipClass="custom-tooltip">
                   <input type="file" accept="image/*" (change)="onFileSelected($event)"/>
                   <img src="assets/img/edit-image.svg" alt="" style="width: 22px; margin-right: 8px;">
                 </label>

								<button type="button" name="button" data-toggle="dropdown">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="12" cy="18" r="2" transform="rotate(-90 12 18)" fill="#a9a9a9"/>
									<circle cx="12" cy="12" r="2" transform="rotate(-90 12 12)" fill="#a9a9a9"/>
									<circle cx="12" cy="6" r="2" transform="rotate(-90 12 6)" fill="#a9a9a9"/>
									</svg>
								</button>

                <div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">

                   <ul class="list-group">
                     <li class="more-option-section" (click)="openPublicDialog()">
                       	<img src="assets/img/redirect.svg" alt="" style="width: 21px; height: 21px; margin-right: 12px;">
                        <a style="color: #333; margin-top:2px; margin-left:0px;" class="text" href="javscript:;">Go public</a>
                     </li>

                     <!-- <li class="more-option-section" (click)="openGetReferralLinkDialog()">
                         <img src="assets/img/redirect.svg" alt="" style="width: 21px; height: 21px; margin-right: 12px;">
                        <a style="color: #333; margin-top:2px; margin-left:0px;" class="text" href="javscript:;">Referral link</a>
                     </li> -->

                     <!-- <li>
                       <img src="assets/img/redirect.svg" alt="" style="width: 22px; margin-right: 12px;">
                       <a style="color: #000;" class="text" href="javscript:;">Go to my public profile</a>
                     </li> -->
                  </ul>
                </div>
							</div>
						</div>
						<div class="title-location">
							<span class="add-bio user-main-title">
                <img *ngIf="userTitleImg" style="margin-right: 3px; margin-left: -2px;" src="assets/img/user-portfolio.svg" alt="">
                {{userApiTitle}}
              </span>
							<span class="add-bio user-main-location">
                <img *ngIf="userLocationImg" style="margin-right: 7px;" src="assets/img/profile-location.svg" alt="">
                {{userApiLocation}}
              </span>
							<span class="add-bio user-main-bio">
                <img *ngIf="userBioImg" style="margin-right: 7px;margin-left: -2px;" src="assets/img/document.svg" alt="">
                <span>{{userApiBio}}</span>
              </span>
              <!-- <hr style="width: 100%;">
              <div class="" style="display: flex;">
                <img [ngClass]="{'green-icon': isOpenWorkChecked}"
                  style="margin-right: 7px; margin-left: -2px;"
                  src="assets/img/thumb.svg"
                  alt=""
                >
                <span class="add-email-bio">Open to new projects</span>
                <label style="position: absolute; right: 12px; height: 22px;" class="switch">
                  <input type="checkbox" [(ngModel)]="isOpenWorkChecked">
                  <span class="slider rounds"></span>
                </label>
              </div> -->

              <!-- <span style="margin-top: 6px" class="add-email-bio">akash.bariar@gmail.com</span> -->
              <!-- <hr style="width: 100%;"> -->

						</div>
						<p class="add-bio" style="margin-top: 24px; cursor: pointer;" (click)="openAddBioDialog()">Add your bio to help others learn more about you. <img src="assets/img/edit-icon.svg" alt=""></p>
						<!-- <div class="star-rating" *ngFor="let star of stars">
  						<img src="{{ starState(star) }}" alt="star" />
						</div> -->

						<p class="add-bio" style="margin-top: 16px; cursor: pointer;" (click)="openAddSocials()">Add your social handles. <img src="assets/img/edit-icon.svg" alt=""></p>

						<div class="all-social-icons">
							<ul class="social-icons">
								<li *ngIf="linkedinLink"><a rel="nofollow" href="{{linkedinLink}}" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
								<li *ngIf="twitterLink"><a rel="nofollow" href="{{twitterLink}}" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
								<li *ngIf="instagramLink"><a rel="nofollow" href="{{instagramLink}}" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
								<li *ngIf="dribbbleLink"><a rel="nofollow" href="{{dribbbleLink}}" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
								<li *ngIf="behanceLink"><a rel="nofollow" href="{{behanceLink}}" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true" style="color: #a9a9a9;"></i></a></li>
							</ul>
			      </div>

					</div>
				</div>

				<div class="col-sm-1">

				</div>

								<!-- <span class="welcome-txt">UI/UX Designer @ Crafttor</span> -->
				<div class="col-sm-8 my-profile-rating-section">
					<!-- <span class="welcome-edit-txt">Get rated by publishing your profile</span>
					<div class="profile-welcome-section">
						<div class="star-rating" *ngFor="let star of stars">
  						<img src="{{ starState(star) }}" alt="star" />
						</div>
					</div> -->
					<div class="profile-options">
						<div class="profile-headings" style="display: flex;">
							<!-- <h4 [ngClass]="{'selected-text': isSelected[0], 'unselected-text': !isSelected[0]}" (click)="projectsClick(0)">Projects</h4> -->
							<h4 [ngClass]="{'selected-text': isSelected[0], 'unselected-text': !isSelected[0]}" (click)="myUploadsClick(0)">My uploads
								<!-- <span *ngIf="showMyUploads">{{myUploadsImagesLength}}</span> -->
							</h4>
							<!-- <h4 [ngClass]="{'selected-text': isSelected[2], 'unselected-text': !isSelected[2]}" (click)="follwoingClick(2)">Following</h4> -->
							<h4 *ngIf="planName != 'Free' && userRole == 'Owner'" [ngClass]="{'selected-text': isSelected[1], 'unselected-text': !isSelected[1]}" (click)="moreClick(1)">More</h4>

              <label class="custom-profile-file-upload" mat-raised-button #tooltip="matTooltip"
              matTooltip="File upload"
              matTooltipPosition="above"
              matTooltipClass="custom-tooltip" *ngIf="showMyUploads">
                <input type="file" accept="application/* && pdf/* && image/* && video/*" multiple (change)="selectUserFiles($event)" />
                  <svg style="margin-top:-4px" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
                          <g id="DAM-Landing-Page-Copy-4" transform="translate(-1312.000000, -111.000000)">
                              <g id="CTA-Copy-3" transform="translate(1296.000000, 96.000000)">
                                  <g id="Add" transform="translate(16.000000, 15.000000)">
                                      <rect id="Rectangle" x="0" y="0" width="18" height="18" rx="4"></rect>
                                      <g id="Group-3" transform="translate(3.000000, 3.000000)" stroke="#2d7cff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                          <line x1="6" y1="0" x2="6" y2="12" id="Path-8"></line>
                                          <line x1="6" y1="0.315789474" x2="6" y2="11.6842105" id="Path-8-Copy" transform="translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) "></line>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg>
                    <!-- <span>Add Images</span> -->
              </label>
						</div>

						<div class="add-btn-circle" *ngIf="showMyProjects" (click)="openAddProjectsDialog()">
							<label class="custom-projects-upload" mat-raised-button #tooltip="matTooltip"
							matTooltip="Add projects"
							matTooltipPosition="above"
							matTooltipClass="custom-tooltip">
									<svg style="margin-right: 10px; margin-top:-4px" width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
											<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<g id="DAM-Landing-Page-Copy-4" transform="translate(-1312.000000, -111.000000)">
															<g id="CTA-Copy-3" transform="translate(1296.000000, 96.000000)">
																	<g id="Add" transform="translate(16.000000, 15.000000)">
																			<rect id="Rectangle" x="0" y="0" width="18" height="18" rx="4"></rect>
																			<g id="Group-3" transform="translate(3.000000, 3.000000)" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
																					<line x1="6" y1="0" x2="6" y2="12" id="Path-8"></line>
																					<line x1="6" y1="0.315789474" x2="6" y2="11.6842105" id="Path-8-Copy" transform="translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) "></line>
																			</g>
																	</g>
															</g>
													</g>
											</g>
									</svg>
										<span>Add Project</span>
							</label>
						</div>
					</div>

					<div class="all-profile-coverage">

						<div class="my-projects" *ngIf="showMyUploads">

              <div class="no-illus-img" *ngIf="showNoDataIllus">
      					<img src="assets/img/empty_file_img.svg">
      					<div>
      						<label class="custom-file-upload-files">
      							<input type="file" accept="application/* && pdf/* && image/* && video/*" multiple (change)="selectUserFiles($event)" />
      								<span style="color: #ffffff;">Add files to upload</span>
      						</label>
      					</div>
      				</div>
						</div>

						<div class="illus-rollup-view row mb-5 mt-2" *ngIf="showMyUploads && !showNoDataIllus">
							<ul class="new-board-media-list" *ngFor="let uploads of myUploadsImagesList; let i = index;">
								<li>
									<div class="inner-card">
										<div class="illus-img-container" data-toggle="modal">
											<span *ngIf="uploads.version_count > 1">
												<svg style="width: 18px; position: absolute; background: #333333; border-radius: 4px; padding: 2px;" class="mr-2 h-4 w-4 text-pigeon-200" fill="white" aria-hidden="true" viewBox="0 0 32 32"><path d="M16 29.75a3.06 3.06 0 01-1.52-.4L4 23.49A2 2 0 014 20l2.19-1.22-2.13-1.25a2 2 0 01-1-1.77 2 2 0 011-1.76l1.77-1-1.78-1a2 2 0 010-3.53l10.43-5.83a3.14 3.14 0 013 0l10.46 5.84a2 2 0 010 3.53l-1.77 1L28 14a2 2 0 011 1.76 2 2 0 01-1 1.77l-2.2 1.23L27.94 20a2 2 0 010 3.53l-10.46 5.83a3.09 3.09 0 01-1.48.39zm-7.72-9.87L5 21.71l10.41 5.9a1.12 1.12 0 001.08 0L27 21.77l-3.29-1.87-6.19 3.46a3.07 3.07 0 01-3 0zm.49-2l6.7 3.75a1.12 1.12 0 001.08 0l6.68-3.74L27 15.78l-2.86-1.63-6.61 3.69a3.09 3.09 0 01-3 0l-6.57-3.7L5 15.74l3.72 2.12zM7 11.37l.19.08 8.24 4.65a1.1 1.1 0 001.07 0l7.11-4L27 10.27 16.53 4.39a1.08 1.08 0 00-1.07 0L5 10.22z"></path></svg>
											</span>

											<div class="img-share-comment dropdown">
												<span *ngIf="uploads.is_fav == true" class="anticon img-favourite-personal"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
														<g id="Icons/Star/Selected" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																<path d="M19.9582598,9.79420394 C19.853521,9.47022168 19.5661608,9.24011372 19.2261869,9.20947335 L14.6081582,8.79015196 L12.7820653,4.51600335 C12.6474186,4.20276356 12.3407707,4 12.0000645,4 C11.6593582,4 11.3527103,4.20276356 11.2180636,4.5167358 L9.39197075,8.79015196 L4.77320957,9.20947335 C4.43384607,9.24084615 4.14721826,9.47022168 4.04186909,9.79420394 C3.93651992,10.1181862 4.03381224,10.4735412 4.29053217,10.6975455 L7.78121503,13.758897 L6.7518939,18.2930615 C6.67657475,18.6264434 6.8059723,18.971056 7.08259016,19.1710119 C7.23127532,19.2784363 7.40522961,19.333125 7.58064877,19.333125 C7.73189746,19.333125 7.88192541,19.2923526 8.01657214,19.2117843 L12.0000645,16.8309909 L15.9820919,19.2117843 C16.2734806,19.3870814 16.6407988,19.3710898 16.9168063,19.1710119 C17.1935462,18.9704456 17.3228217,18.6257109 17.2475026,18.2930615 L16.2181814,13.758897 L19.7088643,10.6981559 C19.9655842,10.4735412 20.063609,10.1187965 19.9582598,9.79420394 Z" id="Star" fill="#FFC107" fill-rule="nonzero"></path>
														</g>
												</svg></span>

												<div data-toggle="dropdown">
													<span class="anticon img-more-options"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
													<circle cx="6" cy="12" r="2" fill="white"/>
													<circle cx="12" cy="12" r="2" fill="white"/>
													<circle cx="18" cy="12" r="2" fill="white"/>
													</svg>
													</span>

												<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
													 <ul class="list-group">
														 <!-- <li class="more-option-section" (click)="downloadSingleImage(uploads.id, uploads.title)">
															 <img src="assets/img/download-black.svg" alt="">
															 <a class="text" href="javscript:;"  style="color:#000">Download</a>
														 </li> -->
														 <li class="more-option-section" (click)="deleteUserSingleUploadedImages(uploads.id)">
															 <img src="assets/img/delete-red.svg" alt="">
															 <a class="text" href="javscript:;"  style="color:#eb1313">Delete</a>
														 </li>
													 </ul>
												 </div>
											 </div>
											</div>

											<video src={{uploads.image}} *ngIf="uploads.image_format == 'MP4' || uploads.image_format == 'WMV' || uploads.image_format == 'MOV' || uploads.image_format == 'FLV' || uploads.image_format == 'WEBM'" style="height: 200px;" controls (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);"></video>

											<img src={{uploads.image}} *ngIf="uploads.image_format == 'PNG' || uploads.image_format == 'JPG'  ||uploads.image_format == 'SVG' || uploads.image_format == 'JPEG' || uploads.image_format == 'GIF'  || uploads.image_format == 'BMP'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src={{uploads.image_jpg}} *ngIf="uploads.image_format == 'WEBP' || uploads.image_format == 'TIFF'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src="assets/img/eps-icon.svg" *ngIf="uploads.image_format == 'EPS'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src="assets/img/ai-icon.svg" *ngIf="uploads.image_format == 'AI'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src="assets/img/zip-icon.svg" *ngIf="uploads.image_format == 'ZIP'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src="assets/img/xlsx-ixon.svg" *ngIf="uploads.image_format == 'XLSX'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src="assets/img/doc-icon.svg" *ngIf="uploads.image_format == 'DOCX' || uploads.image_format == 'DOC'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<img src="assets/img/psd.svg" *ngIf="uploads.image_format == 'PSD'" style="height: 200px;" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">

											<pdf-viewer (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);" style="height: 200px; width:200px;" *ngIf="uploads.image_format == 'PDF'" [src]="uploads.image" [original-size]="true" [render-text]="true" [rotation]="0"
											[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
											[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
											[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

                      <label *ngIf="!imageSelected" class="ill-add-btn select-illus" [style.background-color] = "changeColor[i]  ? '#ffffff' : '#e4e4e4'">
    									<input type="checkbox" value="illus_2" id="illus_2" class="d-none" (click)="changeColor[i]=!changeColor[i]; showDeleteButtons(changeColor[i], i,  uploads.id, uploads.title)">
    									<span class="anticon anticon-check">
    									</span></label>

    									<label *ngIf="imageSelected" class="ill-add-btn- select-illus" [style.background-color] = "changeColor[i]  ? 'green' : '#e4e4e4'">
    									<input type="checkbox" value="illus_2" id="illus_2" class="d-none" (click)="changeColor[i]=!changeColor[i]; showDeleteButtons(changeColor[i], i,  uploads.id, uploads.title)">
    									<span class="anticon anticon-check">
    										<svg *ngIf="changeColor[i] == false" viewBox="64 64 896 896" focusable="false" class="nike-mark" data-icon="check" width="1em" height="1em" fill="#e4e4e4" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
    										<svg *ngIf="changeColor[i] == true" viewBox="64 64 896 896" focusable="false" class="nike-mark-show" data-icon="check" width="1em" height="1em" fill="white" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
    									</span></label>

										</div>

										<div class="hover-style" (click)="currentIllus=uploads; openImgDialog(imgMainModal, currentIllus.title, i, currentIllus.id, currentIllus.image_format);">
											<div class="title" style="text-align: start;"><b>{{ uploads.title }}</b>
												<br>
												<span *ngIf="uploads.size > 1000">{{uploads.image_format}} - {{ uploads.size/1000 }} MB</span>
												<span *ngIf="uploads.size < 1000">{{uploads.image_format}} - {{ uploads.size }} KB</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>

						<div class="profile-followers-area" *ngIf="showMyFollowers">

							<div class="search-user-section">
								<form class="custom-form" (ngSubmit)="onSubmitUser()">
									<div class="side-search-box">
										<div class="search-box-side-bar" id="search-box" style="box-shadow:none">
											<button>
												<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
											</button>
											<input type="" name="searchUser" placeholder="Search user" [(ngModel)]="searchUser">
											<input style="display: none" type="Submit" value="Search" class="button">
										</div>
									</div>
								</form>

								<div class="filter-section">
									<span data-toggle="dropdown"><img style="width: 18px; margin-right: 6px" src="assets/img/filter.svg" alt="">Filter</span>

									<div class="dropdown-menu images-drop-down" aria-labelledby="dropdownMenuButton" data-toggle="dropdown">
										 <ul class="list-group">
												<li class="more-option-section">
												 <a class="text" href="javscript:;" style="color:#000">❤️ <span style="margin-left: 8px;">Heart rated</span></a>
											 </li>

											 <li class="more-option-section">
												 <a class="text" href="javscript:;" style="color:#000">❤️ <span style="margin-left: 8px;">Star rated</span></a>
											 </li>
										 </ul>
									 </div>
								</div>
							</div>

							<div class="images-table-section">
								<table class="table-view-section">
				  				<tr>
								    <th>Name</th>
								    <th>User Id</th>
										<th>Reward</th>
										<th>Follow</th>
								  </tr>
								  <tr>
										<td class="table-size-text">Akash Bariar</td>
										<td class="table-size-text">abariar-0013</td>
										<td class="table-size-text">❤️</td>
										<td class="table-size-text">Follow</td>
								  </tr>
									<tr>
										<td class="table-size-text">Akash Bariar</td>
										<td class="table-size-text">abariar-0013</td>
										<td class="table-size-text">❤️</td>
										<td class="table-size-text">Follow</td>
								  </tr>
									<tr>
										<td class="table-size-text">Akash Bariar</td>
										<td class="table-size-text">abariar-0013</td>
										<td class="table-size-text">❤️</td>
										<td class="table-size-text">Follow</td>
								  </tr>
								</table>
							</div>
						</div>

						<div class="show-more-area" *ngIf="showMoreOptions">

							<div class="no-illus-img" *ngIf="!teamListRatings">
								<img src="assets/img/empty_file_img.svg">
                <div><label>No Team List Found!!</label></div>
								<!-- <div><label style="font-variant: small-caps;">Rewards, ratings & more soon!!.</label></div> -->
							</div>

							<h3 *ngIf="teamListRatings && userRole == 'Owner'">Team Ratings </h3>
              <hr style="margin-bottom: 50px;" *ngIf="teamListRatings && userRole == 'Owner'">
              <!-- <img src="assets/img/edit-icon.svg" alt=""> -->


							<!-- <div class="add-other-socials" *ngIf="showMoreListItems" (click)="viewRewards()">
								<span>View rewards history</span>
								<img src="assets/img/next-arrow.svg" alt="">
							</div>

							<div class="add-other-socials" *ngIf="showMoreListItems" (click)="viewWorkHistory()">
								<span>View work history</span>
								<img src="assets/img/next-arrow.svg" alt="">
							</div> -->

							<div class="images-table-section" *ngIf="showMoreOptions">
								<!-- <p (click)="showMainMoreSection()">
									<svg style="margin-top: -3px;" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
											<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
															<g id="Back" transform="translate(40.000000, 28.000000)">
																	<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
																	<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#a9a9a9" stroke-width="1.5">
																			<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
																			<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
																	</g>
															</g>
													</g>
											</g>
									</svg>
									Back</p> -->
								<table class="table-view-section team-ratings" *ngIf="teamListRatings && userRole == 'Owner'">
				  				<tr>
								    <th>Name</th>
								    <th>Email Id</th>
										<th>Role</th>
                    <th>Reward</th>
                    <th></th>
								  </tr>
                  <tr *ngFor="let user of usersList; let i = index;">
                    <td>{{ user.user_object.first_name + ' ' + user.user_object.last_name }}</td>
                    <td>{{ user.user_object.email }}</td>
                    <td>{{ user.role_title }}</td>
                    <td *ngIf="user.rating == null || user.rating == ''"></td>
                    <td *ngIf="user.rating == 1">😐</td>
                    <td *ngIf="user.rating == 2">🎉</td>
                    <td *ngIf="user.rating == 3">🥉</td>
                    <td *ngIf="user.rating == 4">🥈</td>
                    <td *ngIf="user.rating == 5">🥇</td>
                    <td>
                      <select style="border: 1px solid #fff; border-radius: 4px;" (change)="onSelectEmoji($event.target.value, i, user.user_object.id)">
                        <!-- <option disabled selected>Select Emoji</option> -->
                        <option *ngFor="let emoji of emojis" [value]="emoji.number">{{ emoji.emoji }}</option>
                      </select>
                    </td>
                  </tr>
								</table>
							</div>
						</div>

						<!-- <div class="no-illus-img" *ngIf="showNoDataIllus">
							<img src="assets/img/empty_file_img.svg">
							<div><label>No uploads.</label></div>
						</div> -->
					</div>

          <div class="parent-delete-container">
            <div class="download-delete-section" *ngIf="downloadDelete">

    					<button (click)="deleteUserUploadedImages()" class="ant-btn-default ant-btn-delete img-delete-btn" type="button" name="button">
    						<img style="margin-top: -5px;" src="assets/img/delete-red.svg" alt="">
    						<span style="text-transform: uppercase; margin-left:6px;">DELETE ({{count}} {{fileText}})</span>
    					</button>

              <button (click)="cancelImageSelection()" type="button" class="close cancel-button" data-dismiss="modal" aria-label="Close">
    						<svg id="Icons_Navigation_Cross_Black" data-name="Icons/Navigation/Cross/Black" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    							<defs>
    								<clipPath id="clip-path">
    									<rect id="Mask" width="18" height="18" fill="currentColor"/>
    								</clipPath>
    							</defs>
    							<g id="Group_4" data-name="Group 4" transform="translate(3 3)">
    								<g id="Close_icon" data-name="Close icon">
    									<rect id="Mask-2" data-name="Mask" width="18" height="18" fill="none"/>
    									<g id="Close_icon-2" data-name="Close icon" clip-path="url(#clip-path)">
    										<path id="Shape" d="M0,0,11.25,11.25" transform="translate(3.375 3.375)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
    										<path id="Shape-2" data-name="Shape" d="M11.25,0,0,11.25" transform="translate(3.375 3.375)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
    									</g>
    								</g>
    							</g>
    						</svg>
    					</button>
    				</div>
          </div>

					<div class="loader-scenarios" *ngIf="showTopRightLoader">
						<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
					</div>

					<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulMsg">
						<span class="ant-avatar-selected">
							<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</span>
						<p>{{successfullMessage}}</p>
					</div>

					<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
						<p>{{sendSuccessfulErrorMessage}}</p>
					</div>

				</div>
			</div>
		</div>
	</div>
</section>

<ng-template #imgMainModal let-imgMainModal>
  <div class="modal-dialog modal-dialog-centered svg-modal" role="document">
    <div class="modal-content">
      <div class="modal-body d-flex">
        <div class="public-profile-svg-preview">
          <div class="modal-sep">
            <h4>{{currentIllus.title | slice:0:30}}{{currentIllus.title.length > 30 ? '...' : ''}}</h4>
            <img style="background: #f6f9fe; border-radius: 50%;" class="user-img" *ngIf="!userPic" src="assets/img/user-profile.svg">
						<img class="user-img" *ngIf="userPic" src="{{userPic}}">

            <a (click)="imgMainModal.close()" class="close-main-dialog">
              <svg width="24px" height="24px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
                    <g id="DAM-Landing-Page-Copy-3" transform="translate(-911.000000, -23.000000)">
                        <g id="Cross" transform="translate(912.000000, 24.000000)">
                            <rect id="Rectangle" x="0" y="0" width="24" height="24" rx="4"></rect>
                            <g id="Group-3" transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" stroke="#000000" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="8" y1="0" x2="8" y2="16" id="Path-8"></line>
                                <line x1="8" y1="0.421052632" x2="8" y2="15.5789474" id="Path-8-Copy" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></line>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
            </a>

           <div class="svg-preview-container">
             <span *ngIf="myUploadsImagesList.length > 1 && showPreviousIcon" aria-hidden="true" (click)="previousImage(currentIllusPosition)" class="previos-icon">
               <svg style="background-color: #f5f6f7; border-radius: 40px; transform: rotate(180deg);" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
             </span>

            <pdf-viewer *ngIf="currentIllus.image_format == 'PDF'" [src]="currentIllus.image" [original-size]="true" [render-text]="true" [rotation]="0"
            [show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
            [stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
            [show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>

            <input type="checkbox" id="zoomCheck" style="display: none;">
              <label for="zoomCheck">
                <img src="assets/img/psd.svg" *ngIf="currentIllus.image_format == 'PSD'">

                <img [src]="currentIllus.image" alt="download illustrations" *ngIf="currentIllus.image_format == 'PNG' || currentIllus.image_format == 'JPG'  ||currentIllus.image_format == 'SVG' || currentIllus.image_format == 'JPEG' || currentIllus.image_format == 'GIF' || currentIllus.image_format == 'BMP'">

                <img [src]="currentIllus.image_jpg" *ngIf="currentIllus.image_format == 'WEBP' || currentIllus.image_format == 'TIFF'">

                <img src="assets/img/ai-icon.svg" *ngIf="currentIllus.image_format == 'AI'">

                <img src="assets/img/eps-icon.svg" *ngIf="currentIllus.image_format == 'EPS'">

                <img src="assets/img/zip-icon.svg" *ngIf="currentIllus.image_format == 'ZIP'">

                <img src="assets/img/doc-icon.svg" *ngIf="currentIllus.image_format == 'DOCX' || currentIllus.image_format == 'DOC'">

                <img src="assets/img/xlsx-icon.svg" *ngIf="currentIllus.image_format == 'XLSX'">
              </label>

              <video src={{currentIllus.image}} *ngIf="currentIllus.image_format == 'MP4' || currentIllus.image_format == 'WEBM' || currentIllus.image_format == 'FLV' || currentIllus.image_format == 'WMV' || currentIllus.image_format == 'MOV'" controls></video>

              <span *ngIf="myUploadsImagesList.length > 1 && showNextIcon" class="next-icon" aria-hidden="true" (click)="nextImage(currentIllusPosition)">
                <svg style="background-color: #f5f6f7; border-radius: 40px;" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 23.1421L20.0711 16.071L13 8.99995" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
          </div>
        </div>
      </div>
      <hr>
     </div>
    </div>
  </div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 50px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':addProfileDetailsStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<button type="button" class="close" (click)="closeAddBioDialog()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
			<div class="mt-2 share-class-permit profile-dialog-area">
				<h2 class="profile-dialog-header">Edit your profile</h2>
				<div class="" style="display: inline-grid;">
					<img *ngIf="!userPic" class="profile-user-img" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" class="profile-user-img" src="{{userPic}}">
					<!-- <label>
						<h6 class="change-pic-txt">Change picture</h6>
						<input type="file" accept="image/*" (change)="onFileSelected($event)"/>
					</label> -->
				</div>

				<div class="form-wrapper">
						<form class="row g-3" [formGroup]="addBioForm">
							<div class="col-md-12">
								<label class="form-label">Title<span>*</span></label>
								<input [(ngModel)]="userTitle" id="textinput" formControlName="title" type="text" placeholder="UI/UX Designer, Illustrator ..." class="form-control input-md" required>
							</div>
							<div class="col-md-12">
								<label class="form-label">Location</label>
								<input [(ngModel)]="userLocation" id="textinput" formControlName="location" type="text" placeholder="Gurugram" class="form-control input-md">
							</div>
							<div class="col-md-12">
								<label class="form-label">Your bio</label>
								<input [(ngModel)]="userBio" id="textinput" formControlName="bio" type="text" placeholder="Add about your creative work and more..." class="form-control input-md">
							</div>

							<div class="col-7">
							</div>

							<div class="col-2">
								<button id="singlebutton" name="singlebutton button" class="btn cancel-btn" (click)="closeAddBioDialog()">Cancel</button>
							</div>

							<div class="col-3">
								<button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showProfileDetailsLeaveLoader" (click)="submitUserBio()">Save</button>
								<button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="showProfileDetailsLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 100px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':addDesignationStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<button type="button" class="close" (click)="closeDesignationStyle()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit profile-dialog-area">
					<h2 class="profile-dialog-header">Add designation</h2>
					<img *ngIf="!userPic" class="profile-user-img" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" class="profile-user-img" src="{{userPic}}">
		      <div class="form-wrapper">
		        <form class="row g-3" [formGroup]="addDesignationForm" (ngSubmit)="submitYourDesignation()">
		          <div class="col-md-12">
		          	<label class="form-label">Add designation<span>*</span></label>
		          	<input id="textinput" formControlName="designation" type="text" placeholder="UI/UX Designer @ Crafttor" class="form-control input-md" required>
		          </div>

							<div class="col-7">
		          </div>

							<div class="col-2">
			          <button id="singlebutton" name="singlebutton button" class="btn cancel-btn" (click)="closeDesignationStyle()">Cancel</button>
		          </div>

		          <div class="col-3">
			          <!-- <button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showLeaveLoader">Save</button> -->
			          <button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
		          </div>
		        </form>
		      </div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 100px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':addProjectsStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<button type="button" class="close" (click)="closeAddProjectsDialog()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit profile-dialog-area">
					<h2 class="profile-dialog-header">Add projects</h2>
					<img *ngIf="!userPic" class="profile-user-img" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" class="profile-user-img" src="{{userPic}}">
		      <div class="form-wrapper">
		        <form class="row g-3" [formGroup]="addProjectsForm" (ngSubmit)="submitYourProjects()">
		          <div class="col-md-12">
		          	<label class="form-label">Add project<span>*</span></label>
		          	<input id="textinput" formControlName="project" type="text" placeholder="https://workspace.crafttor.com/jhabjhagduyaba" class="form-control input-md">
		          </div>

							<div class="col-7">
		          </div>

							<div class="col-2">
			          <button id="singlebutton" name="singlebutton button" class="btn cancel-btn" (click)="closeAddProjectsDialog()">Cancel</button>
		          </div>

		          <div class="col-3">
			          <button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showLeaveLoader" (click)="submitYourProjects()">Save</button>
			          <button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
		          </div>
		        </form>
		      </div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 50px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':addSocialsStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<button type="button" class="close" (click)="closeAddSocials()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit profile-dialog-area">
					<h3 class="profile-dialog-header">Add your Social Handles</h3>
					<div class="form-wrapper">
		        <form class="row g-3" [formGroup]="addSocialsForm">
							<div class="col-md-12">
		          	<label class="form-label">Add LinkedIn</label>
		          	<input id="textinput" formControlName="linkedin" type="text" placeholder="https://linkedin.com" class="form-control input-md" [(ngModel)]="linkedinLink">
		          </div>

		          <div class="col-md-12">
		          	<label class="form-label">Add Twitter</label>
		          	<input id="textinput" formControlName="twitter" type="text" placeholder="https://twitter.com" class="form-control input-md" [(ngModel)]="twitterLink">
		          </div>

							<div class="col-md-12">
		          	<label class="form-label">Add Instagram</label>
		          	<input id="textinput" formControlName="instagram" type="text" placeholder="https://instagram.com" class="form-control input-md" [(ngModel)]="instagramLink">
		          </div>

							<div class="col-md-12">
		          	<label class="form-label">Add Dribbble</label>
		          	<input id="textinput" formControlName="dribbble" type="text" placeholder="https://dribbble.com" class="form-control input-md" [(ngModel)]="dribbbleLink">
		          </div>

							<div class="col-md-12">
		          	<label class="form-label">Add Behance</label>
		          	<input id="textinput" formControlName="behance" type="text" placeholder="https://behance.com" class="form-control input-md" [(ngModel)]="behanceLink">
		          </div>

							<div class="col-7">
		          </div>

							<div class="col-2">
			          <button id="singlebutton" name="singlebutton button" class="btn cancel-btn" (click)="closeAddSocials()">Cancel</button>
		          </div>

		          <div class="col-3">
			          <button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="!showProjectsLeaveLoader" (click)="submitSocials()">Save</button>
			          <button id="singlebutton" name="singlebutton button" class="btn btn-primary save-btn" *ngIf="showProjectsLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
		          </div>
		        </form>
		      </div>
				</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 100px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':shareProfileDetailsStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
			<button type="button" class="close" (click)="closePublicDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg">
			</button>
			<div class="img-container-modal">
			   <img src={{shareImageLink}}>
			</div>
			<div class="mt-2 share-class-permit">
				<h3 class="share-a-link">Go public</h3>
				<hr>

				<div class="main-permit-sec">
					<div class="allow-download-sec">
						<div data-toggle="dropdown">
							<h5>Share Projects <img src="assets/img/tool-tip.svg" alt="" mat-raised-button #tooltip="matTooltip"
		        	matTooltip="Share your project details."
		        	matTooltipPosition="above"
							matTooltipClass="custom-tooltip"></h5>
							<p class="dropdown-menu allow-download-info">Share your project details.</p>
	          </div>
						<div class="allow-checkbox">
							<label *ngIf="planName != 'Free'" class="switch-share-settings" [(ngModel)]="allowProjectsSelected" (change)="allowShareProjects()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>

							<p class="go-pro" *ngIf="planName == 'Free'" routerLink="/dam/subscription">Go pro</p>
						</div>
					</div>

					<!-- <div class="allow-download-sec">
						<div data-toggle="dropdown">
							<h5>Share Socials <img src="assets/img/tool-tip.svg" alt="" mat-raised-button #tooltip="matTooltip"
		        	matTooltip="Assets can be downloaded by users with whom you share it."
		        	matTooltipPosition="above"
							matTooltipClass="custom-tooltip"></h5>
							<p class="dropdown-menu allow-download-info">Share your social details.</p>
	          </div>
						<div class="allow-checkbox">
							<label *ngIf="planName != 'Free'" class="switch-share-settings" [(ngModel)]="allowSocialsSelected" (change)="allowShareSocials()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>

							<p class="go-pro" *ngIf="planName == 'Free'" routerLink="/dam/subscription">Go pro</p>
						</div>
					</div> -->
				</div>
				<button *ngIf="!linkGenerated && !showLeaveLoader" class="generate-share-link" (click)="generatePublishLink()">Generate Link</button>
				<button *ngIf="!linkGenerated && showLeaveLoader" class="generate-share-link"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
				<div *ngIf="linkGenerated" class="d-flex email-input-share-link mt-3">
					<div class="share-link-field">
						<input type="" name="" value="{{publicProfileShareLink}}" class="" placeholder="Generated Link" #copysharelink>
					</div>
					<button class="create-share-link" (click)="publishProfile(copysharelink)">Publish</button>
				</div>
				<div class="no-account-txt" *ngIf="showGenerateLinkError">
					<p style="text-align: center; margin-top: 4px; color: #eb1313">{{linkErrorMsg}}</p>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':shareReferralLinkStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
			<button type="button" class="close" (click)="closeGetReferralLinkDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg">
			</button>
			<div class="img-container-modal">
			   <img src={{shareImageLink}}>
			</div>
			<div class="mt-2 share-class-permit">
				<h3 class="share-a-link">Referral Link</h3>
				<hr>

				<div class="main-permit-sec">

				</div>
				<button *ngIf="!linkGenerated && !showLeaveLoader" class="generate-share-link" (click)="generatePublishLink()">Generate Link</button>
				<button *ngIf="!linkGenerated && showLeaveLoader" class="generate-share-link"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
				<div *ngIf="linkGenerated" class="d-flex email-input-share-link mt-3">
					<div class="share-link-field">
						<input type="" name="" value="{{publicProfileShareLink}}" class="" placeholder="Generated Link" #copyLink>
					</div>
					<button class="create-share-link" (click)="copyReferralLink(copyLink)">Copy</button>
				</div>
				<div class="no-account-txt" *ngIf="showGenerateLinkError">
					<p style="text-align: center; margin-top: 4px; color: #eb1313">{{linkErrorMsg}}</p>
				</div>
        <div class="no-account-txt" *ngIf="showLinkCopied">
					<div class="link-copied">
						<p>Copied to clipboard</p>
					</div>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>
